/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { DiskScalingContext } from './disk-scaling-context';
// May contain unused imports in some cases
// @ts-ignore
import type { SizeScalingContext } from './size-scaling-context';

/**
 * ScalingReason explains a single decision made by the engine.  A response may carry multiple independent reasons (e.g. IOPS_SATURATION and LOW_FREE_SPACE).
 * @export
 * @interface ScalingReason
 */
export interface ScalingReason {
    /**
     * Identifies what triggered this scaling decision.
     * @type {string}
     * @memberof ScalingReason
     */
    'code'?: ScalingReasonCodeEnum;
    /**
     * Populated for size decisions (LOW_FREE_SPACE, PREEMPTIVE_SIZE_HEADROOM).
     * @type {SizeScalingContext}
     * @memberof ScalingReason
     */
    'sizeContext'?: SizeScalingContext;
    /**
     * Populated for performance decisions (IOPS_SATURATION, IOPS_UNDERUTILIZED,  THROUGHPUT_SATURATION, THROUGHPUT_UNDERUTILIZED).  Identifies the disk whose observed metrics triggered the decision.
     * @type {DiskScalingContext}
     * @memberof ScalingReason
     */
    'triggeringDisk'?: DiskScalingContext;
}

export const ScalingReasonCodeEnum = {
    SCALING_REASON_CODE_UNSPECIFIED: 'SCALING_REASON_CODE_UNSPECIFIED',
    IOPS_SATURATION: 'IOPS_SATURATION',
    IOPS_UNDERUTILIZED: 'IOPS_UNDERUTILIZED',
    THROUGHPUT_SATURATION: 'THROUGHPUT_SATURATION',
    THROUGHPUT_UNDERUTILIZED: 'THROUGHPUT_UNDERUTILIZED',
    LOW_FREE_SPACE: 'LOW_FREE_SPACE',
    PREEMPTIVE_SIZE_HEADROOM: 'PREEMPTIVE_SIZE_HEADROOM'
} as const;

export type ScalingReasonCodeEnum = typeof ScalingReasonCodeEnum[keyof typeof ScalingReasonCodeEnum];


